export enum FpEllerEsRoutes {
    OM = '/om',
    SITUASJON = '/situasjon',
    OPPSUMMERING = '/oppsummering',
}
